import { Injectable } from '@angular/core';
import { AppRepository } from '../repositories/app.repository';
import { CalendarEvent } from 'src/app/pages/apps/aio-table/interfaces/calendar-event.model';
declare var gapi: any;

const CLIENT_ID = '112796379741-g0j4k2alarijfeu40le2gfd31d8opbde.apps.googleusercontent.com';
const API_KEY = 'AIzaSyA-qFOyRzAzneKTaS771kWhePKEPXZGU-A';
// const CLIENT_ID = '564992429987-cbhfjtre6fclcos605nupoc5aib4q31i.apps.googleusercontent.com'; // test
// const API_KEY = 'AIzaSyACG4gvW2lNgTbfQxB2LI2i4xARNxLjsxE'; // test
const DISCOVERY_DOCS = [
    'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'
];
const SCOPES = 'profile email';

@Injectable()
export class GapiSession {
    googleAuth: gapi.auth2.GoogleAuth;

    constructor(
        private appRepository: AppRepository

    ) {
    }

    initClient() {
        return new Promise((resolve, reject) => {
            gapi.load('client:auth2', () => {
                return gapi.client.init({
                    apiKey: API_KEY,
                    clientId: CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES,
                }).then(() => {
                    gapi.client.load('calendar', 'v3', () => {
                        console.log('loaded calendar');
                    });
                    this.googleAuth = gapi.auth2.getAuthInstance();
                    resolve();
                });
            });
        });

    }
    get isSignedIn(): boolean {
        return this.googleAuth.isSignedIn.get();
    }

    signIn() {
        return this.googleAuth.signIn({
            prompt: 'consent'
        }).then((googleUser: gapi.auth2.GoogleUser) => {
            this.appRepository.User.add(googleUser.getBasicProfile());
            const emailUser = googleUser.getBasicProfile().getEmail();
            const nombreUser = googleUser.getBasicProfile().getName();
            const urlImagen = googleUser.getBasicProfile().getImageUrl();
            localStorage.clear();

            localStorage.setItem('e15x2m', btoa(emailUser));
            localStorage.setItem('n15x2b', btoa(nombreUser));
            localStorage.setItem('u15x2i', btoa(urlImagen));
        });
    }

    signOut(): void {
        this.googleAuth.signOut();
    }

    addCalendarEntry(calendarEvent: CalendarEvent) {
        gapi.client.calendar.events.insert({
            calendarId: calendarEvent.calendarId || 'primary',
            start: {
                dateTime: calendarEvent.start,
                timeZone: 'America/Bogota'
            },
            end: {
                dateTime: calendarEvent.end,
                timeZone: 'America/Bogota'
            },
            summary: calendarEvent.summary,
            description: calendarEvent.description
        }).then(result => {
            console.log('Result', result);
        }).catch(error => console.error('Error creating calendar event', error));
    }
}